import { useLocale, useTranslations } from 'next-intl';
import { routing } from '@/i18n/routing';
import LocaleSwitcherSelect from '@components/LocaleSwitcherSelect';

export default function LocaleSwitcher({
  align = 'center',
  showLanguage,
}: {
  align?: 'center' | 'start' | 'end';
  showLanguage?: boolean;
}) {
  const t = useTranslations('localeSwitcher');
  const locale = useLocale();

  return (
    <LocaleSwitcherSelect
      defaultValue={locale}
      label={t('label')}
      align={align}
      showLanguage={showLanguage}
    >
      {routing.locales.map((cur) => ({
        key: cur,
        value: cur,
        label: t(cur),
      }))}
    </LocaleSwitcherSelect>
  );
}
